import { DataService } from "base/services";
import { useAccountStore } from "base/stores";

export const ProfileService = {
  async getProfile() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.get(`/user/2/${_id}/me`);
    return await apiCall();
  },
  async getUserProfile(userId) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.get(`/user/2/${_id}/${userId}`);
    return await apiCall();
  },
  async saveProfile(updatedData) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.update(`/user/2/${_id}/me`, {
      data: updatedData
    });
    return await apiCall();
  },
  async saveProfileSettings(updatedData) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.update(`/user/2/${_id}/me/settings`, {
      data: updatedData
    });
    return await apiCall();
  },
  async getProfileSettings() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.get(`/user/2/${_id}/me/settings`);
    return await apiCall();
  },
  async revokeDelegation() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.delete(`/user/2/${_id}/me/delegation`);
    return await apiCall();
  },
  async getDebugAPIKey() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.post(`/user/2/${_id}/debug/key`);
    return await apiCall();
  },
  async createApiKey(userId, details) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.post(`/user/2/${_id}/api/`, { data: details });
    return await apiCall();
  },
  async updateApiKey(apiKey, details) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = DataService.update(`/user/2/${_id}/api/${apiKey}`, {
      data: details
    });
    return await apiCall();
  },
  async getApiKeys() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.get(
      `/user/2/${_id}/api?page_number=1&page_size=50`
    );
    return await apiCall();
  },
  async deleteApiKey(apiKey) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.delete(`/user/2/${_id}/api/${apiKey}`);
    return await apiCall();
  },

  async getUserSessions(userId, currentPage, rowsPerPage) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.get(
      `/signin/2/${_id}/${userId}` +
        `/session?page_number=${currentPage}&page_size=${rowsPerPage}`
    );
    return await apiCall();
  },
  async deleteAllSessions(userId) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.delete(
      `/signin/2/${_id}/${userId}/session`
    );
    return await apiCall();
  },
  async deleteUserSession(userId, sessionId) {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.delete(
      `/signin/2/${_id}/${userId}/session/${sessionId}`
    );
    return await apiCall();
  },
  async getAppContext() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.get(`/signin/2/${_id}/context`);
    return await apiCall();
  },
  async signOut() {
    const { _id } = useAccountStore.getState();
    let [apiCall] = await DataService.post(`/signin/2/${_id}/logout`, {
      data: {}
    });
    return await apiCall();
  }
};
